import React, {Component} from "react";
import Modal from "../Modal/Modal";
import iconCaution from "../../assets/images/icons/ic_caution.svg";
import iconChevron from "../../assets/images/icons/ic_chevron_warning.svg";
import iconArrow from "../../assets/images/icons/ic_arrow_right_warning.svg";
import iconWarning from "../../assets/images/icons/ic_warning.svg";
import blankJacket from "../../assets/images/icons/blank_jacket.gif";
import * as Styled from "./Style";

class CartMessaging extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCustomMessageModalOpen: "",
      cartMessageIsbn: {
        cartMessageDigitalAccessCodeList: this.props.cartMessageDigitalAccessCodeList,
        cartMessageSecondHandIsbnList: this.props.cartMessageSecondHandIsbnList,
        cartMessageDigitalResourceList: this.props.cartMessageDigitalResourceList,
        cartMessageFamilyNames: this.props.cartMessageFamilyNames,
      },
      familyWithIsbns: [],
      modalFamilyName: "",
      modalFamilyIsbns: [],
    };
  }

  componentDidMount() {
    this.getCartMessage();
    this.state.cartMessageIsbn.cartMessageFamilyNames.map((familyName) => {
      this.state.cartMessageIsbn.cartMessageSecondHandIsbnList.map((isbnItem) => {
        if (familyName == isbnItem.familyName) {
          this.state.familyWithIsbns.push(familyName);
        }
      });
    });
  }

  getCartMessage = () => {
    if (this.state.cartMessageIsbn) {
      this.setState(
        {
          cartMessageStatic: {
            headerMsg: "Important messages for your items in your bag",
            digitalAccessCodeMsg:
              "<b>Digital only</b> products require a Cambridge GO account to activate.",
            secondhandIsbnMsg: "If you do not have a secondhand textbook, do not purchase this reactivation code.",
            secondhandIsbnPrefixMsg: "This reactivation code will give access to",
            productNoteTitle: "Product Note",
            productNoteBodyTop: "Please ensure you are buying the correct edition reactivation code.",
            productNoteBodyBottom:
              "This reactivation code cannot be activated without the 16-character code on the inside front cover of your second-hand textbook.",
            productNoteWarning: "If you do not have a secondhand textbook, do not purchase this reactivation code.",
            secondHandMsg: "Your second-hand textbook should look like this: ",
            reactivationCodeEdMsg:
              "Access to the digital resource is not available immediately upon purchase of a print and digital textbook resource. The access code is located on the inside front cover of the book and can be activated when your print textbook is received.",
            learnMoreLabel: "Learn more about the second-<br/>hand textbooks",
            itemsDigitalAccessCodeTextSingle: "item in bag with a digital only access code",
            itemsDigitalAccessCodeTextMultiple: "items in bag with a digital only access code",
            itemsSecondhandIsbnTextSingle: "item in bag with a reactivation code",
            itemsSecondhandIsbnTextMultiple: "items in bag with a reactivation code",
            itemsCombinedTextSingle: "item in bag with combined print and digital resources",
            itemsCombinedTextMultiple: "items in bag with combined print and digital resources",
            isbnLabel: "ISBN",
            ensureCorectReactivation: "Ensure you are buying the correct edition reactivation code.",
          },
        },
        () => {}
      );
    }
  };

  onToggleCustomMessage = (familyName, familyIsbns) => {
    this.setState({modalFamilyName: familyName, modalFamilyIsbns: familyIsbns}, () => {
      console.log(this.state.modalFamilyIsbns, "modalFamilyIsbns");
    });
    if (this.state.isCustomMessageModalOpen) {
      this.setState({isCustomMessageModalOpen: ""});
      document.getElementsByTagName("html")[0].classList.remove("modal-open");
    } else {
      this.setState({isCustomMessageModalOpen: "isOpen"});
      document.getElementsByTagName("html")[0].classList.add("modal-open");
    }
  };
  render() {
    return this.state.cartMessageStatic ? (
      <Styled.CartMessaging className="custom-cart-messaging-wrapper">
        <div className="tabs">
          <div className="tab">
            <input type="checkbox" id={"custom-msg-toggle-" + this.props.id} defaultChecked={window.innerWidth <= 576 ? false : true} />
            <label className="tab-label" htmlFor={"custom-msg-toggle-" + this.props.id}>
              <img src={`${iconCaution}`} alt="" />
              <span className="tab-title">{this.state.cartMessageStatic.headerMsg}</span>
              <span className="tab-toggle">
                <img src={`${iconChevron}`} alt="" />
              </span>
            </label>
            <div className="tab-content">
              {/* ==================== Digital Resource ==================== */}

              {this.state.cartMessageIsbn.cartMessageDigitalResourceList.length > 0 ? (
                <div id="digital-resource" className="msg-item">
                  <span className="msg-title">
                    {this.state.cartMessageIsbn.cartMessageDigitalResourceList.length}{" "}
                    {this.state.cartMessageIsbn.cartMessageDigitalResourceList.length > 1
                      ? this.state.cartMessageStatic.itemsCombinedTextMultiple
                      : this.state.cartMessageStatic.itemsCombinedTextSingle}
                  </span>
                  <p>{this.state.cartMessageStatic.reactivationCodeEdMsg}</p>
                  <ul>
                    {this.state.cartMessageIsbn.cartMessageDigitalResourceList
                      .filter(function (item, index) {
                        return index < 3;
                      })
                      .map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                  </ul>
                  <input type="checkbox" id={"digital-resource-toggle" + this.props.id} className="list-see-more-check" />
                  {this.state.cartMessageIsbn.cartMessageDigitalResourceList.length > 3 ? (
                    <div className="list-see-more-toggle">
                      <label htmlFor={"digital-resource-toggle" + this.props.id} className="warning-link list-see-more-label">
                        <img src={`${iconChevron}`} alt="" />
                        <span className="showmore-label">Show {this.state.cartMessageIsbn.cartMessageDigitalResourceList.length - 3} more</span>
                      </label>
                    </div>
                  ) : (
                    ""
                  )}
                  <ul className="more-list">
                    {this.state.cartMessageIsbn.cartMessageDigitalResourceList
                      .filter(function (item, index) {
                        return index > 2;
                      })
                      .map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                  </ul>
                </div>
              ) : (
                ""
              )}

              {/* ==================== Secondhand ISBN ===================== */}

              {this.state.cartMessageIsbn.cartMessageSecondHandIsbnList.length > 0 ? (
                <div id="secondhand-isbn" className="msg-item">
                  <span className="msg-title">
                    {this.state.cartMessageIsbn.cartMessageSecondHandIsbnList.length}{" "}
                    {this.state.cartMessageIsbn.cartMessageSecondHandIsbnList.length > 1
                      ? this.state.cartMessageStatic.itemsSecondhandIsbnTextMultiple
                      : this.state.cartMessageStatic.itemsSecondhandIsbnTextSingle}
                  </span>
                  <p className="msg-subtitle">{this.state.cartMessageStatic.secondhandIsbnMsg}</p>
                  {this.state.cartMessageIsbn.cartMessageFamilyNames.map((familyItem, index) => (
                    <div key={index} className={`secondhand-isbn-item ${!this.state.familyWithIsbns.includes(familyItem) ? "hidden" : ""}`}>
                      <p className="msg-subtitle">{this.state.cartMessageStatic.ensureCorectReactivation}</p>
                      <p>
                        {this.state.cartMessageStatic.secondhandIsbnPrefixMsg} <strong>{familyItem} only</strong>.
                      </p>
                      <ul>
                        {this.state.cartMessageIsbn.cartMessageSecondHandIsbnList
                          .filter(function (item, index) {
                            return familyItem == item.familyName;
                          })
                          .slice(0, 3)
                          .map((item, index) => (item.secondHandIsbn != "" && familyItem == item.familyName ? <li key={index}>{item.cartItemTitle}</li> : ""))}
                      </ul>
                      {/* Begin show more  */}
                      <input type="checkbox" id={"secondhand-isbn-toggle-" + index} className="list-see-more-check" />
                      {this.state.cartMessageIsbn.cartMessageSecondHandIsbnList
                        .filter(function (item, index) {
                          return familyItem == item.familyName;
                        })
                        .filter(function (item, index) {
                          return index > 2;
                        })
                        .map((item, index) => <li key={index}>{item.cartItemTitle}</li>).length > 0 ? (
                        <div className="list-see-more-toggle">
                          <label htmlFor={"secondhand-isbn-toggle-" + index} className="warning-link list-see-more-label">
                            <img src={`${iconChevron}`} alt="" />
                            <span className="showmore-label">
                              Show{" "}
                              {
                                this.state.cartMessageIsbn.cartMessageSecondHandIsbnList
                                  .filter(function (item, index) {
                                    return familyItem == item.familyName;
                                  })
                                  .filter(function (item, index) {
                                    return index > 2;
                                  })
                                  .map((item, index) => <li key={index}>{item.cartItemTitle}</li>).length
                              }{" "}
                              more
                            </span>
                          </label>
                        </div>
                      ) : (
                        ""
                      )}
                      <ul className="more-list">
                        {this.state.cartMessageIsbn.cartMessageSecondHandIsbnList
                          .filter(function (item, index) {
                            return familyItem == item.familyName;
                          })
                          .filter(function (item, index) {
                            return index > 2;
                          })
                          .map((item, index) => (
                            <li key={index}>{item.cartItemTitle}</li>
                          ))}
                      </ul>
                      {/* End show more  */}
                      <p className="see-details">
                        <span
                          className="warning-link see-details-toggle"
                          tabIndex="0"
                          onClick={() =>
                            this.onToggleCustomMessage(
                              familyItem,
                              this.state.cartMessageIsbn.cartMessageSecondHandIsbnList.filter(function (item, index) {
                                return familyItem == item.familyName;
                              })
                            )
                          }
                          onKeyPress={(e) => {
                            if (e.key === " ") {
                              this.onToggleCustomMessage(
                                familyItem,
                                this.state.cartMessageIsbn.cartMessageSecondHandIsbnList.filter(function (item, index) {
                                  return familyItem == item.familyName;
                                })
                              );
                            }
                          }}>
                          <span dangerouslySetInnerHTML={{__html: this.state.cartMessageStatic.learnMoreLabel}}></span> <img src={`${iconArrow}`} alt="" />
                        </span>
                      </p>
                    </div>
                  ))}
                </div>
              ) : (
                ""
              )}

              {/* ==================== Digital Access Code ==================== */}

              {this.state.cartMessageIsbn.cartMessageDigitalAccessCodeList.length > 0 ? (
                <div id="digital-access-code" className="msg-item">
                  <span className="msg-title">
                    {this.state.cartMessageIsbn.cartMessageDigitalAccessCodeList.length}{" "}
                    {this.state.cartMessageIsbn.cartMessageDigitalAccessCodeList.length > 1
                      ? this.state.cartMessageStatic.itemsDigitalAccessCodeTextMultiple
                      : this.state.cartMessageStatic.itemsDigitalAccessCodeTextSingle}
                  </span>
                  <p dangerouslySetInnerHTML={{__html: this.state.cartMessageStatic.digitalAccessCodeMsg}}></p>
                  <ul>
                    {this.state.cartMessageIsbn.cartMessageDigitalAccessCodeList
                      .filter(function (item, index) {
                        return index < 3;
                      })
                      .map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                  </ul>
                  <input type="checkbox" id="digital-access-code-toggle" className="list-see-more-check" />
                  {this.state.cartMessageIsbn.cartMessageDigitalAccessCodeList.length - 3 > 0 ? (
                    <div className="list-see-more-toggle">
                      <label htmlFor="digital-access-code-toggle" className="warning-link list-see-more-label">
                        <img src={`${iconChevron}`} alt="" />
                        <span className="showmore-label">Show {this.state.cartMessageIsbn.cartMessageDigitalAccessCodeList.length - 3} more</span>
                      </label>
                    </div>
                  ) : (
                    ""
                  )}

                  <ul className="more-list">
                    {this.state.cartMessageIsbn.cartMessageDigitalAccessCodeList
                      .filter(function (item, index) {
                        return index >= 3;
                      })
                      .map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                  </ul>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <Modal show={this.state.isCustomMessageModalOpen} close={() => this.onToggleCustomMessage()} classes="custom-messaging-modal">
          <h2 className="title">{this.state.cartMessageStatic.productNoteTitle}</h2>
          <div className="custom-messaging-modal-content">
            <p>{this.state.cartMessageStatic.productNoteBodyTop}</p>
            <p>
              {this.state.cartMessageStatic.secondhandIsbnPrefixMsg} <strong>{this.state.modalFamilyName} only</strong>.
            </p>
            <p>{this.state.cartMessageStatic.productNoteBodyBottom}</p>
            <p className="warning-note">
              <span className="warning-icon-wrapper">
                <img src={`${iconWarning}`} alt="" className="warning-icon" />
              </span>
              <span>{this.state.cartMessageStatic.productNoteWarning}</span>
            </p>
            <p>{this.state.cartMessageStatic.secondHandMsg}</p>
            <ul className="prod-item-list">
              {this.state.modalFamilyIsbns
                ? this.state.modalFamilyIsbns.map((item, index) => (
                    <li key={index} className="prod-item">
                      <div className="prod-item-title">
                        <span className="bullet">&#8226; </span>
                        <span>{item.cartItemTitle}</span>
                      </div>
                      <div className="product-card-wrapper">
                        <div className="product-card">
                          <div className="prod-card-isbn">
                            <strong>{this.state.cartMessageStatic.isbnLabel}: </strong>
                            {item.secondHandIsbn}
                          </div>
                          <div className="prod-card-img">
                            <img src={item.secondHandIsbnCover ? item.secondHandIsbnCover : blankJacket} />
                          </div>
                        </div>
                      </div>
                    </li>
                  ))
                : ""}
            </ul>
          </div>
          <div className="custom-messaging-modal-footer">
            <button className="link-as-btn" onClick={() => this.onToggleCustomMessage()}>
              Close
            </button>
          </div>
        </Modal>
      </Styled.CartMessaging>
    ) : (
      ""
    );
  }
}

export default CartMessaging;
